import Icon from '@/components/snippets/icon/icon'
import { formatMoney } from '@/components/helpers/currency-formatter'
import { PRICE_FILTER_FIELD, RANGE_INDICATOR } from './FilterUtils'
import { globalState } from '@/components/helpers/utils'
import { isSizeFilter, formatUniversalSizeValue } from './SizeFilterUtils'

export function FilterSelected({ activeFilters, onRemove }) {
  if (!activeFilters || activeFilters.size === 0) return null

  const formatFilterValue = (filter) => {
    const [field, value] = filter.split(':')

    if (field === PRICE_FILTER_FIELD) {
      const [min, max] = value.split(RANGE_INDICATOR)
      const formatMin =
        parseFloat(min) % 1 === 0
          ? globalState.shopify.moneyFormat.replace('amount', 'amount_no_decimals')
          : globalState.shopify.moneyFormat
      const formatMax =
        parseFloat(max) % 1 === 0
          ? globalState.shopify.moneyFormat.replace('amount', 'amount_no_decimals')
          : globalState.shopify.moneyFormat
      return `${formatMoney(parseFloat(min) * 100, formatMin)} ↔ ${formatMoney(parseFloat(max) * 100, formatMax)}`
    }

    if (isSizeFilter(field, value)) {
      return formatUniversalSizeValue(value).replaceAll(RANGE_INDICATOR, '↔')
    }

    return value.replaceAll(RANGE_INDICATOR, '↔')
  }

  return (
    <div class="flex gap-x-0.5 overflow-x-auto overscroll-none whitespace-nowrap border-b border-neutral-medium px-1.5 py-1.5 no-scrollbar">
      {[...activeFilters].map((filter) => {
        return (
          <button
            class="font-heading paragraph-xs flex size-fit shrink-0 items-center justify-center gap-x-0.625 rounded-8 bg-brand-neutral-light px-1 py-0.5 font-medium uppercase link-fade"
            onClick={() => onRemove(filter)}
            aria-label={`Remove ${formatFilterValue(filter)} filter`}
          >
            {formatFilterValue(filter)}
            <div className="flex size-[9px] children:size-full">
              <Icon id="close" />
            </div>
          </button>
        )
      })}
    </div>
  )
}
